import UserSignInComponents from "../../components/UserSignInComponent"
import SignUpHeader from "./components/signUpHeader"
import SignUpContent from "./components/signUpContent"
function SignUp () {
    return (
        <>
            <UserSignInComponents>
                <SignUpHeader/>
                <SignUpContent/>
            </UserSignInComponents>
        </>
    )
}

export default SignUp;